export interface IPromoBank {
  /** ID банка **/
  id: number;
  /** Название **/
  name: string;
  /** Ссылка на страницу ипотеки для партнеров **/
  cianMortgagePartnerLink?: string | null;
  /** Логотип банка **/
  logoUrl?: string | null;
  /** Круглое лого банка **/
  secondRoundImageUrl?: string | null;
  /** Квадратное лого банка **/
  secondSquareImageUrl?: string | null;
  /** Является ли партнером Циан ипотеки **/
  isPartner?: boolean | null;
}

export interface IMortgageParams {
  /** Процентная ставка (0.0 - 100.0) **/
  interestRate?: number | null;
  /** Максимальная сумма кредита **/
  maxCredit?: number | null;
  /** Максимальный срок, лет **/
  maxLoanTerm?: number | null;
  /** Первоначальный взнос в %(0.0 - 100.0) **/
  minInitialPaymentRate?: number | null;
}

export enum EPromoType {
  Bank = 'bank',
  /** Бонусы **/
  Bonus = 'bonus',
  /** ЦИАН ипотека **/
  CianMortgage = 'cianMortgage',
  /** Скидки **/
  Discount = 'discount',
  /** Материнский капитал **/
  MaternalCapital = 'maternalCapital',
  /** Военная ипотека **/
  MilitaryMortgage = 'militaryMortgage',
  /** Ипотека **/
  Mortgage = 'mortgage',
  /** Рассрочка **/
  Installment = 'installment',
}

export interface IPromoInfo {
  /** Логотип застройщика/агента **/
  authorLogoUrl?: string;
  /** Название (имя) застройщика/агента **/
  authorName?: string;
  /** Realty user id, разместившего акцию **/
  authorRealtyUserId?: number;
  /** Список ЖК в которых доступна акция **/
  availableJks?: IAvailableJk[];
  /** Доступные условия покупки **/
  availablePurchaseTerms?: string[];
  /** Банк - автор **/
  bank?: IPromoBank;
  /** Банки **/
  banks: IPromoBank[];
  /** ID компании, разместившей акцию **/
  companyId?: number;
  /** Описание акции **/
  description?: string;
  /** Лейблы акции для диалога **/
  dialogLabels: IPromoLabel[];
  /** Срок действия акции **/
  end?: string;
  /** Особенности акци **/
  features?: IPromoFeature[];
  /** Акция от банка **/
  isFromBank?: boolean;
  /** Акция от застройщика **/
  isFromBuilder: boolean;
  /** Параметры акции по ипотеке **/
  mortgageParams?: IMortgageParams;
  /** Название акции **/
  name: string;
  /** ID Акции. Deprecated (используй unique_promo_id) **/
  promoId: number;
  /** Изображение для акции **/
  promoImage?: string;
  /** Юридические условия акции **/
  promoLegalTerms?: string;
  /** Тип акции **/
  promoType: EPromoType;
  /** Дата начала действия акции **/
  start?: string;
  /** Подзаголовок акции **/
  subtitle?: string;
  /** ID акции **/
  uniquePromoId: string;
  /** Флаг главной акции **/
  isMainPromo?: boolean;
}

export interface IPromoFeature {
  /** Название **/
  name: string;
  /** Значение **/
  value: string;
  /** Изменение значения **/
  valueChange?: IPromoFeatureValueChange;
}

export interface IPromoFeatureValueChange {
  /** Диалоговое окно с описанием изменения значения **/
  dialog?: IValueChangeDialog;
  /** Новое значение **/
  newValue: string;
  /** Подзаголовок **/
  subtitle: string;
}

export interface IValueChangeDialog {
  /** Описание **/
  description: string;
  /** Ссылка на изображение **/
  imageUrl?: string;
  /** Заголовок **/
  title: string;
}

export interface IAvailableJk {
  /** ID ЖК **/
  id: number;
  /** Ссылка на карточку ЖК **/
  link: string;
  /** Название **/
  name: string;
}

export interface IPromoModalConfig {
  listingBaseUrlDesktop: string;
  listingBaseUrlMobile: string;
  fullCreditPriceModalText: string;
}

export interface IPromoLabel {
  /** Текст **/
  text: string;
  /** Тип метки **/
  type: string;
}
